function getUniqueKey(item) {
  return String(item.date);
}

/**
 * 深度对比
 * 规则：
 * 1. 仅 discount_need_arr / room_need_arr / meeting_need_arr 下的 list 数组 → date主键匹配
 * 2. add_need_arr.list / offer_info / 其他数组 全部按下标对比
 * 3. 旧空数组新增，数组不标edit，子项标add
 * @param {*} oldData 旧数据
 * @param {*} newData 新数据
 * @returns {*} 带add/edit标记结构
 */
function deepDiffMark(oldData, newData) {
  // 内部递归，parentPath 记录层级路径
  function innerDiff(old, newVal, parentPath) {
    if (old === newVal) return newVal;

    const oldIsArr = Array.isArray(old);
    const newIsArr = Array.isArray(newVal);

    // 一边数组一边非数组，整体标记edit
    if (oldIsArr !== newIsArr) {
      return {
        type: "edit",
        old: old,
        value: newVal
      };
    }

    if (oldIsArr && newIsArr) {
      // 旧空数组，新数据全部子项add
      if (old.length === 0 && newVal.length > 0) {
        const resArr = [];
        for (let i = 0; i < newVal.length; i++) {
          resArr.push({
            type: "add",
            value: innerDiff({}, newVal[i], [...parentPath, i])
          });
        }
        return resArr;
      }

      // 精准判断：路径倒数第二层是指定三类，当前层是list，才走date主键
      let isTargetDateList = false;
      const pathLen = parentPath.length;
      // 路径至少两层：[父对象key, "list"]
      if (pathLen >= 2 && parentPath[pathLen - 1] === "list") {
        const parentObjKey = parentPath[pathLen - 2];
        const targetKeys = ["discount_need_arr", "room_need_arr", "meeting_need_arr"];
        if (targetKeys.includes(parentObjKey)) {
          isTargetDateList = true;
        }
      }

      if (isTargetDateList) {
        // date主键匹配逻辑
        const oldKeyMap = new Map();
        old.forEach(item => {
          const k = getUniqueKey(item);
          oldKeyMap.set(k, item);
        });
        const resArr = [];
        newVal.forEach((newItem, idx) => {
          const k = getUniqueKey(newItem);
          const matchOld = oldKeyMap.get(k);
          if (!matchOld) {
            resArr.push({
              type: "add",
              value: innerDiff({}, newItem, [...parentPath, idx])
            });
          } else {
            resArr.push(innerDiff(matchOld, newItem, [...parentPath, idx]));
          }
        });
        return resArr;
      } else {
        // add_need_arr.list / offer_info / 其他数组：按下标对比
        const resArr = [];
        const maxLen = Math.max(old.length, newVal.length);
        for (let i = 0; i < maxLen; i++) {
          const oldItem = old[i];
          const newItem = newVal[i];
          if (i >= old.length) {
            resArr.push({
              type: "add",
              value: innerDiff({}, newItem, [...parentPath, i])
            });
            continue;
          }
          if (i >= newVal.length) continue;
          resArr.push(innerDiff(oldItem, newItem, [...parentPath, i]));
        }
        return resArr;
      }
    }

    // 对象遍历，记录字段名到路径
    const oldIsObj = old && typeof old === "object";
    const newIsObj = newVal && typeof newVal === "object";
    if (oldIsObj && newIsObj) {
      const resObj = {};
      const keys = new Set([...Object.keys(old), ...Object.keys(newVal)]);
      for (const key of keys) {
        const hasOld = key in old;
        const hasNew = key in newVal;
        const ov = old[key];
        const nv = newVal[key];

        if (hasOld && !hasNew) continue;

        if (!hasOld && hasNew) {
          resObj[key] = {
            type: "add",
            value: innerDiff({}, nv, [...parentPath, key])
          };
          continue;
        }
        resObj[key] = innerDiff(ov, nv, [...parentPath, key]);
      }
      return resObj;
    }

    // 基础类型值不同
    return {
      type: "edit",
      old: old,
      value: newVal
    };
  }

  // 入口，初始路径空数组
  return innerDiff(oldData, newData, []);
}
// /**
//  * 获取数组项唯一主键
//  * 仅外层 list 条目（含date）用date匹配；内层offer_info不使用此key，按下标对比
//  * @param {Object} item 数组对象
//  * @returns {string} 唯一key
//  */
// function getUniqueKey(item) {
//   // 只有带date的外层数据才走主键匹配
//   if (item.hasOwnProperty('date')) {
//     return String(item.date);
//   }
//   // 内层offer房型不走主键，这里随便返回，不会被内层数组使用
//   return '';
// }

// /**
//  * 深度对比
//  * 第一层list数组：按date主键匹配，不按下标
//  * 第二层offer_info数组：默认按下标顺序对比
//  * 规则：旧空数组新增项只标add；值全等直接返回原值不生成edit
//  * @param {*} oldData 旧数据
//  * @param {*} newData 新数据
//  * @returns {*} 带edit/add标记结构
//  */
// function deepDiffMark(oldData, newData) {
//   if (oldData === newData) return newData;

//   const oldIsArr = Array.isArray(oldData);
//   const newIsArr = Array.isArray(newData);

//   // 一边数组一边非数组，整体标记edit
//   if (oldIsArr !== newIsArr) {
//     return {
//       type: "edit",
//       old: oldData,
//       value: newData
//     };
//   }

//   if (oldIsArr && newIsArr) {
//     // 旧数组为空，新数组全部标记add
//     if (oldData.length === 0 && newData.length > 0) {
//       const res = [];
//       for (let i = 0; i < newData.length; i++) {
//         res.push({
//           type: "add",
//           value: deepDiffMark({}, newData[i])
//         });
//       }
//       return res;
//     }

//     // 判断当前数组是否是外层list（子项包含date）
//     const isOuterDateList = oldData.length > 0 && oldData[0].hasOwnProperty('date');

//     // 外层list：按date主键匹配
//     if (isOuterDateList) {
//       const oldKeyMap = new Map();
//       oldData.forEach(oldItem => {
//         const key = getUniqueKey(oldItem);
//         oldKeyMap.set(key, oldItem);
//       });

//       const resultArr = [];
//       newData.forEach(newItem => {
//         const key = getUniqueKey(newItem);
//         const matchOld = oldKeyMap.get(key);

//         if (!matchOld) {
//           resultArr.push({
//             type: "add",
//             value: deepDiffMark({}, newItem)
//           });
//         } else {
//           resultArr.push(deepDiffMark(matchOld, newItem));
//         }
//       });
//       return resultArr;
//     } else {
//       // 内层offer_info等普通数组：默认按下标对比（你原来最初的逻辑）
//       const resArr = [];
//       const maxLen = Math.max(oldData.length, newData.length);
//       for (let i = 0; i < maxLen; i++) {
//         const oldItem = oldData[i];
//         const newItem = newData[i];

//         if (i >= oldData.length) {
//           resArr.push({
//             type: "add",
//             value: deepDiffMark({}, newItem)
//           });
//           continue;
//         }
//         if (i >= newData.length) continue;

//         resArr.push(deepDiffMark(oldItem, newItem));
//       }
//       return resArr;
//     }
//   }

//   // 对象处理
//   const oldIsObj = oldData && typeof oldData === "object" && !oldIsArr;
//   const newIsObj = newData && typeof newData === "object" && !newIsArr;
//   if (oldIsObj && newIsObj) {
//     const resObj = {};
//     const keys = new Set();
//     Object.keys(oldData).forEach(k => keys.add(k));
//     Object.keys(newData).forEach(k => keys.add(k));
//     const allKeys = Array.from(keys);

//     for (let i = 0; i < allKeys.length; i++) {
//       const k = allKeys[i];
//       const hasOld = oldData.hasOwnProperty(k);
//       const hasNew = newData.hasOwnProperty(k);
//       const ov = oldData[k];
//       const nv = newData[k];

//       if (!hasNew) continue;
//       if (!hasOld) {
//         resObj[k] = {
//           type: "add",
//           value: deepDiffMark({}, nv)
//         };
//         continue;
//       }
//       resObj[k] = deepDiffMark(ov, nv);
//     }
//     return resObj;
//   }

//   // 基础值不同标记edit
//   return {
//     type: "edit",
//     old: oldData,
//     value: newData
//   };
// }
function isObjectArray(value, allowEmpty = true) {
    // 第一步：先判断是否为数组
    if (!Array.isArray(value)) {
      return false;
    }
  
    // 第二步：处理空数组（根据配置决定是否视为对象数组）
    if (value.length === 0) {
      return allowEmpty;
    }
  
    // 第三步：判断数组中每一个元素是否为有效普通对象（非null、非数组、纯对象）
    return value.every(item => {
      return typeof item === 'object' && item !== null && !Array.isArray(item);
    });
  }
  /**
 * 2. 遍历对象，仅将对象数组属性转为JSON，其他属性保持原值（不修改原对象）
 * @param {Object} obj - 待处理的目标对象
 * @param {boolean} [format=true] - 是否格式化JSON（2空格缩进），默认开启
 * @param {boolean} [allowEmptyObjectArray=false] - 是否允许空对象数组转JSON
 * @returns {Object} 处理后的新对象
 */
function convertOnlyObjectArrayToJson(obj, format = true, allowEmptyObjectArray = false) {
    // 入参校验：非有效对象直接返回，避免报错
    if (typeof obj !== 'object' || obj === null) {
      console.warn('入参不是有效对象，无法进行处理');
      return obj;
    }
    const newObj = {};
    // 仅遍历对象的自有可枚举属性，避免处理继承属性
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      // 仅对对象数组进行JSON转换，其他属性保持原值
      if (isObjectArray(value, allowEmptyObjectArray)) {
        try {
          newObj[key] = JSON.stringify(value);
        } catch (e) {
          console.error(`属性${key}对应的对象数组转JSON失败：`, e.message);
          newObj[key] = value; // 转换失败时保留原值
        }
      } else {
        newObj[key] = value;
      }
    });
    return newObj;
  }
const object = {
    /**
     * 提取两个对象所有交集键对应的第二个对象值（不依赖第一个对象的键范围）
     * @param {Object} obj1 - 第一个对比对象
     * @param {Object} obj2 - 第二个对比对象
     * @returns {Object} 第二个对象的交集键值
     */
    getSecondObjIntersectionValues (obj1, obj2){
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        console.error('参数必须为对象');
        return {};
        }
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        // 找两个对象的交集键
        const commonKeys = keys1.filter(key => keys2.includes(key));
        const result = {};
        commonKeys.forEach(key => {
        result[key] = obj2[key];
        });
        return result;
    },
    
    /**
     * 将对象中值含逗号的字段转为数组（支持嵌套对象、空值、全空格处理）
     * @param {Object} obj - 待处理的对象
     * @param {Boolean} trim - 是否去除数组元素首尾空格（默认true）
     * @param {Boolean} skipEmpty - 是否跳过空值/纯空格值（默认false，空值转为空数组）
     * @returns {Object} 处理后的新对象
     */
    convertCommaValueToArray (obj, trim = true, skipEmpty = false){
        // 非对象直接返回（容错）
        if (typeof obj !== 'object' || obj === null) {
        console.warn('参数必须为非空对象');
        return obj;
        }
        const result = {};
        // 遍历对象所有键
        Object.keys(obj).forEach(key => {
        const value = obj[key];
        // 嵌套对象递归处理
        if (typeof value === 'object' && value !== null) {
            result[key] = this.convertCommaValueToArray(value, trim, skipEmpty);
            return;
        }
        // 非字符串类型直接保留原值
        if (typeof value !== 'string') {
            result[key] = value;
            return;
        }
        // 去除首尾空格（可选）
        const processedValue = trim ? value.trim() : value;
        // 跳过空值（可选）
        if (skipEmpty && processedValue === '') {
            result[key] = '';
            return;
        }
    
        // 含逗号则分割为数组，否则保留原值（空值转为空数组）
        if (processedValue.includes(',')) {
            result[key] = processedValue.split(',').map(item => trim ? item.trim() : item);
        } else {
            result[key] = processedValue === '' ? [] : processedValue;
        }
        });
        return result;
    },
    /**
     * 俩个对象合并只合并第一个存在的key
     */
    mergeByFirstKey(obj1, obj2) {
        const result = { ...obj1 }
        // 遍历obj1所有key，存在于obj2就赋值
        Object.keys(result).forEach(key => {
            if (key in obj2) {
            result[key] = obj2[key]
            }
        })
        return result
    },
        /**
     * 清空对象中 undefined、null、空字符串 等无效属性
     * @param {Object} obj - 待处理对象
     * @param {Array} keepKeys - 要保留的属性名数组（可选）
     * @returns {Object} 处理后的新对象
     */
    removeEmptyProps(obj, keepKeys = []) {
        if (typeof obj !== 'object' || obj === null) {
        return obj;
        }
    
        const newObj = {};
        for (const key in obj) {
        // 只处理自身属性
        if (!obj.hasOwnProperty(key)) continue;
    
        const value = obj[key];
        
        // ====================== 关键：保留字段直接通过 ======================
        if (keepKeys.includes(key)) {
            newObj[key] = value;
            continue;
        }
    
        // 过滤空值：undefined、null、空字符串、空数组
        if (
            value !== undefined &&
            value !== null &&
            value !== '' &&
            // 数组判断（空数组过滤）
            !(Array.isArray(value) && value.length === 0)
        ) {
            newObj[key] = value;
        }
        }
        return newObj;
    },
    /**
     * @param {Number|String} targetId 要查找的id
     * @param {Array} arr 目标数组
     * @param {String} key 匹配字段名 如'id','roomId'
     * @returns {Boolean} 是否存在
     */
    hasIdInArr(targetId, arr, key = 'id') {
        if (!Array.isArray(arr) || !targetId) return false
        // some找到一项即返回true，性能优于filter+length
        return arr.some(item => item[key] === targetId)
    }
}

export default {
    ...object,
    convertOnlyObjectArrayToJson:convertOnlyObjectArrayToJson,
    deepDiffMark:deepDiffMark
};
